<!--  价格策略列表 -->
<template>
	<div class='page_content'>
		<subComponents  ref="showSelectData"></subComponents>
		<priceStrategyAction  ref="priceStrategyAction"></priceStrategyAction>
		<div class="page_content_top">
			<div class="page_content_top_line">
				<el-button type="primary"  size="mini" @click="actionSet(buttonValue)" v-for="(buttonValue,buttonKey) in buttonList" :key="buttonKey">
					{{buttonValue.jurName}}
				</el-button>
				<el-button type="primary" icon="el-icon-refresh"  size="mini" @click="getDataList()" >
					刷新
				</el-button>
			</div>
			<div class="page_content_top_line">
				<el-form :inline="true" :model="getRequestData" class="demo-form-inline" size="mini">
					<el-form-item label="商品">
						<el-input   v-model.trim="getRequestData.bgmName" clearable @focus="$refs['showSelectData'].openBox('businessGoodsList','bgmId','bgmId')">
						</el-input>
					</el-form-item>
					
					<el-form-item>
						<el-button type="primary"  size="mini" @click="searchData">查询</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<div class="page_content_center">
			<el-table   stripe  :data="returnData.list"  height="100%" border style="width: 100%" highlight-current-row>
				<el-table-column   label="数据选择" width="82">
					<template  slot-scope="scope">
						<el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
							<i class="el-icon-thumb"></i>
						</el-radio>
					</template>
				</el-table-column>
				<el-table-column prop="bgmName"   label="通用名称">
				</el-table-column>
				<el-table-column prop="bgmManufacturer"   label="生产厂家">
				</el-table-column>
				<el-table-column prop="bgmPlaceorigin"   label="产地">
				</el-table-column>
				<el-table-column prop="bgmSpecifications"   label="规格">
				</el-table-column>
				<el-table-column prop="pmMinderate"   label="最低扣率">
				</el-table-column>
				<el-table-column prop="pmMinprice"   label="最低售价">
				</el-table-column>
				<el-table-column prop="pmPrice"   label="售价">
				</el-table-column>
				<el-table-column prop="prgGname"   label="价格策略组名称">
				</el-table-column>
			</el-table>
		</div>
		<div class="page_content_bottom">
			<el-pagination
				background
				@size-change="setDataPageSize"
				@current-change="setDataPageNumber"
				:current-page="getRequestData.page"
				:page-sizes="[30,50,100,500]"
				:page-size="30"
				layout="total, sizes, prev, pager, next, jumper"
				:total="returnData.total">
			</el-pagination>
		</div>
		
	</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

 import priceStrategyAction from "@/components/priceStrategyAction.vue";
export default {
	//import引入的组件需要注入到对象中才能使用
	components: {
		priceStrategyAction
	},
	data() {
		//这里存放数据
		return {
			
			getRequestData:{
				bgmId:"",
				bgmName:"",
				page:1,
				rows:30,
				start:'',
				end:'',
			},
			returnData:{
				pages:0,  // 总页数
				total:0,  // 总条数
				pageNum:0,  // 当前页数
				list:[]
			},
			buttonList:[],
			selectedDataIndex:0,
		};
	},
	//监听属性 类似于data概念
	computed: {},
	//监控data中的数据变化
	watch: {
		'getRequestData.bgmName':{
			handler:function(newValue,oldValue){
				if(newValue==''){
					this.getRequestData.bgmId = ''
				}
			},
			deep:true,
		}
	},
	//方法集合
	methods: {

		isShowData(name,value){
			switch(name){
				case 'bgmId':
					var dataInfo = sessionStorage.getItem('selectBusinessGoodsEntryInfo')
					if(dataInfo){
						dataInfo = JSON.parse(dataInfo)
						this.getRequestData.bgmId = dataInfo.bgmId
						this.getRequestData.bgmName = dataInfo.bgmName
					}
				break;
				default:
					this.getRequestData[name] = value
				
			}
		},
		// 动作集合
		actionSet(actionData){
			switch(actionData.actionType){
				case 0:
					this.$refs.priceStrategyAction.openBox(0,'')
					break;
				case 1:
					if(this.returnData.list.length<=0){
						this.$message({
							message: '暂无数据',
							type: 'error'
						});
						return false
					}
					var  dataInfo = this.returnData.list[this.selectedDataIndex]
					if(!dataInfo){
						this.$message({
							message: '请先选中要操作的数据',
							type: 'error'
						});
						return false
					}
					var sendData = JSON.parse(JSON.stringify(dataInfo))
					this.$refs.priceStrategyAction.openBox(1,sendData)
					break;
				case 2:
					this.delDataAction()
					break;
				
			}
		},
		// 数据搜索
		searchData() {
			this.getRequestData.page = 1
			this.getDataList()
		},
		// 数据翻页
		setDataPageNumber(val){
			this.getRequestData.page = val
			this.getDataList()
		},
		
		// 切换显示条数
		setDataPageSize(val){
			this.getRequestData.page = 1
			this.getRequestData.rows = val
			this.getDataList()
		},
		
		
		// 获取数据列表
		async getDataList(){
			let responseData =  await this.$http.getPriceStrategy(this.getRequestData)
			if(responseData.status == 200){
				this.returnData.list = responseData.result.list
				this.returnData.pages = responseData.result.pages
				this.returnData.total = responseData.result.total
				this.returnData.pageNum = responseData.result.pageNum
				this.selectedDataIndex = 0
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
		
		
		// 删除数据
		delDataAction(){
			if(this.returnData.list.length<=0){
				this.$message({
					message: '暂无数据',
					type: 'error'
				});
				return false
			}
			var  dataInfo = this.returnData.list[this.selectedDataIndex]
			if(!dataInfo){
				this.$message({
					message: '请先选中要操作的数据',
					type: 'error'
				});
				return false
			}
			var sendData = JSON.parse(JSON.stringify(dataInfo))
			this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async()=> {
				var delData = {
					ids:[dataInfo.prmId]
				}
				let responseData =  await this.$http.delPriceStrategy(delData)
				if(responseData.status == 200){
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
					this.getDataList()
				}else{
					this.$message({
						message: responseData.message,
						type: 'error'
					});
				}
				
			}).catch(() => {});
			
		},
	
		async getButtonList(){
			this.buttonList = await this.$common.getActionButton()
		},
	},
	//生命周期 - 创建完成（可以访问当前this实例）
	created() {
		this.getDataList()
		this.getButtonList()
		
	},
	//生命周期 - 挂载完成（可以访问DOM元素）
	mounted() {

	},
	beforeCreate() {}, //生命周期 - 创建之前
	beforeMount() {}, //生命周期 - 挂载之前
	beforeUpdate() {}, //生命周期 - 更新之前
	updated() {}, //生命周期 - 更新之后
	beforeDestroy() {}, //生命周期 - 销毁之前
	destroyed() {}, //生命周期 - 销毁完成
	activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
